import { Close } from "@mui/icons-material";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Toolbar,
  Typography
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  onApply?: () => void;
  applyLabel?: string;
  applyDisabled?: boolean;
  applyColour?: "success" | "error" | "primary" | "secondary";
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  children: React.ReactNode;
  disableContentPadding?: boolean;
};

export default function OprDialog({
  open,
  onClose,
  title,
  onApply,
  applyLabel,
  applyDisabled = false,
  applyColour = "success",
  maxWidth = "sm",
  disableContentPadding,
  children
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      slotProps={{ paper: { sx: { backgroundImage: "none" } } }}
    >
      <AppBar color="brand" position="static">
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: "inherit",
              flex: 1
            }}
          >
            {title}
          </Typography>
          <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
            <Close />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent dividers sx={{ p: disableContentPadding ? 0 : 2 }}>
        {children}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
        <Button onClick={onClose} color="error" variant="outlined">
          Close
        </Button>
        {onApply && (
          <Button onClick={onApply} disabled={applyDisabled} color={applyColour} variant="contained">
            {applyLabel || "Apply"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
